import { Grid, Paper } from "@mui/material";
import Container from "../UI/Container";
import { useEffect, useState } from "react";
import { findPixTransacaoByCurrentInstituicao } from "./api-pix-transacao";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import Loading from "../UI/Loading";
import PixTransacaoPageV2 from "./PixTransacaoPageV2";

const PixTransacaoContainer = () => {
  const [pixTransacaoPage, setPixTransacaoPage] = useState({
    content: [],
    size: 0,
    totlaElements: 0,
    number: 0,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchDataPixTransacao(0);
    // eslint-disable-next-line
  }, []);

  const fetchDataPixTransacao = (newPage) => {
    setIsLoading(true);
    findPixTransacaoByCurrentInstituicao(newPage).then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setPixTransacaoPage(data);
        }
      }
      setIsLoading(false);
    });
  };

  const handleChangePage = (event, newPage) => {
    fetchDataPixTransacao(newPage);
  };

  return (
    <Container component={Paper}>
      <Grid container spacing={3}>
        <Grid size={12}>
          {isLoading ? (
            <Loading description="Carregando Pix Transação" />
          ) : (
            <PixTransacaoPageV2
              pixTransacaoPage={pixTransacaoPage}
              handleChangePage={handleChangePage}
            />
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default PixTransacaoContainer;
